import i18n from 'i18next';

/**
 * The chats inbox skeleton's own namespace (SL-1908, part 4). The skeleton is in
 * the initial bundle (RouteSkeleton, the agent layout, the router), so it must
 * not import the `inbox` namespace — about 57KB of copy every user would download
 * before any screen. It carries only what the skeleton says: its label.
 * `__tests__/i18nParity.test.ts` keeps the three languages in step.
 */
export const NS = 'inbox-skeleton';

export const en = { loading: 'Loading conversations' };
export const es: typeof en = { loading: 'Cargando conversaciones' };
export const pt: typeof en = { loading: 'Carregando conversas' };

// Guarded so importing this module is safe where the i18next singleton isn't
// initialized (the jest runner); in the app it is, before the first render.
if (typeof i18n.addResourceBundle === 'function') {
  i18n.addResourceBundle('en', NS, en, true, true);
  i18n.addResourceBundle('es', NS, es, true, true);
  i18n.addResourceBundle('pt', NS, pt, true, true);
}
